// extracted by mini-css-extract-plugin
module.exports = {"progressTabs":"ProgressTabs_progressTabs__2hNOA","tab":"ProgressTabs_tab__1c9hw","active":"ProgressTabs_active__23wJu","arrow":"ProgressTabs_arrow__3kjhy"};